import WebStorageStub from './WebStorageStub';
import WebStorage from './WebStorage';

const DEBUG_KEY = 'hb_sf_debug';

const storageUtil = {
  checkLocalStorage() {
    let result;

    try {
      window.localStorage.setItem(DEBUG_KEY, 'debug_value');
      result = true;
      window.localStorage.removeItem(DEBUG_KEY);
    } catch (exception) {
      result = false;
    }

    return result;
  },

  checkSessionStorage() {
    let result;

    try {
      window.sessionStorage.setItem(DEBUG_KEY, 'debug_value');
      result = true;
      window.sessionStorage.removeItem(DEBUG_KEY);
    } catch (exception) {
      result = false;
    }

    return result;
  },

  checkWebStorage() {
    return {
      local: this.checkLocalStorage(),
      session: this.checkSessionStorage(),
    };
  },

  createWebStorage(storage, type) {
    return new WebStorage(storage, type);
  },

  createWebStorageStub(type) {
    return new WebStorageStub(type);
  },

  isStorageQuotaException(exception) {
    return exception.code === DOMException.QUOTA_EXCEEDED_ERR;
  },
};

export default storageUtil;
